import React, { useState } from "react";
import loadable from "@loadable/component"
const SettingsComponent=loadable(
  ()=>import("../../components/Settings/Settings")
)

const Settings = () => {
  return (
    <>
      <SettingsComponent/>
    </>
  );
};

export default Settings;
